import React from "react";
import { PlusIcon } from "@heroicons/react/24/outline";

export default function FileInput(props) {

    const hiddenFileInput = React.useRef(null);
    const uploadFile = (event) => {
        hiddenFileInput.current.click();
    };

    const handleFileChange = (event) => {
        const files = Array.from(event.target.files);

        if (props.multiple) {
            props.handleChange(props.name, files);
        } else {
            props.handleChange(props.name, files[0]);
        }
    };

    return (
        <div className={props.containerStyle ? props.containerStyle : ""}>
            {props.label && <label htmlFor={props.name} className={props.labelClassName ? props.labelClassName : "text-sm font-medium text-gray-700 dark:text-gray-200"}>
                {props.label}
            </label>}
            <div className="mt-2 flex flex-row gap-4 items-start">
                <button type='button' onClick={uploadFile} className="flex justify-center gap-2 py-2 px-4 border dark:border-gray-700 border-transparent rounded-md shadow-sm text-sm font-medium text-primary bg-white dark:bg-gray-900">
                    <PlusIcon className="h-5 w-5 text-primary" aria-hidden="true" />
                    {props.buttonText}
                </button>
                <input
                    onChange={handleFileChange}
                    type="file"
                    multiple={props.multiple ?? false}
                    name={props.name}
                    ref={hiddenFileInput}
                    style={{ display: 'none' }} />
            </div>
            {props.errorMessage && <p className="mt-2 text-sm text-red-600" id={`${props.name}-error`}>
                {props.errorMessage}
            </p>}
        </div>
    )

}